import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>
					This Prior Authorization has already been completed by another pharmacy or DME provider. Please verify the Prior Authorization Number with the prescriber.
				</p>
			</div>
		);
	}
}